const STORAGE_PREFIX = "onboarding_v1_";
const listeners = new Set();

export function hasSeenTour(tourKey) {
  return localStorage.getItem(`${STORAGE_PREFIX}${tourKey}_seen`) === "true";
}

export function markTourSeen(tourKey) {
  localStorage.setItem(`${STORAGE_PREFIX}${tourKey}_seen`, "true");
  listeners.forEach((listener) => listener(tourKey));
}

// Lets a dependent tour (see TOUR_DEPENDENCIES) react the instant the tour
// it's waiting on finishes, instead of polling localStorage.
export function onTourSeen(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export function resetTour(tourKey) {
  localStorage.removeItem(`${STORAGE_PREFIX}${tourKey}_seen`);
}

export function resetAllTours(tourKeys) {
  tourKeys.forEach(resetTour);
}
